import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import '../index.global.scss';
import theme from './theme.scss';
export default _object_spread({}, theme);
